import { useTranslation } from 'react-i18next';

export default function DemoCTA() {
  const { t } = useTranslation();
  return (
    <section id="demo" className="py-24 bg-gray-900 relative overflow-hidden">
      {/* Primary blue + secondary green accent */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 via-transparent to-emerald-900/15 pointer-events-none" />
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-3xl lg:text-5xl font-bold text-white mb-6">
          {t('home.demoCta.title')}
        </h2>
        <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
          {t('home.demoCta.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-12">
          <a
            href="https://app.geofleet.ai/signup"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 transition-all shadow-lg shadow-blue-500/30 whitespace-nowrap cursor-pointer"
          >
            {t('home.demoCta.ctaTrial')}
            <i className="ri-arrow-right-line text-white text-sm" />
          </a>
          <a
            href="https://meetings.hubspot.com/aditya145"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-medium text-white border-2 border-emerald-500 hover:bg-emerald-500/20 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-line text-emerald-400" />
            {t('home.demoCta.ctaDemo')}
          </a>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-8 text-gray-400 text-sm">
          <div className="flex items-center space-x-2">
            <i className="ri-checkbox-circle-fill"></i>
            <span>{t('home.demoCta.noCard')}</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-checkbox-circle-fill"></i>
            <span>{t('home.demoCta.freeTrial')}</span>
          </div>
          <div className="flex items-center space-x-2">
            <i className="ri-checkbox-circle-fill"></i>
            <span>{t('home.demoCta.cancelAnytime')}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
